import React, { Component } from 'react';
import VimeoVideo from "./appraisal/vimeo-video";
// import jsPDF from 'jspdf';
import moment from 'moment';
import { forEach, random } from 'lodash';
import ZoomebleImage from '../../ZoomebleImage';
// import html2canvas from 'html2canvas';

let pickup = [], pickupAppraisalPath = [];
let dropoff = [], dropoffAppraisalPath = [];

const isValidImageUrl = (url) => {
  if (typeof url !== "string") return false;

  const cleaned = url.trim();

  if (!cleaned) return false;
  if (["null", "undefined", "false"].includes(cleaned)) return false;

  // basic URL sanity check
  try {
    new URL(cleaned);
    return true;
  } catch {
    return false;
  }
};
export default class JobFullDetailsAppraisal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      appraisal_data: props.appraisal_data || null,
      type: props.type || null,
      isLoadingAppraisalInfo: props.isLoadingAppraisalInfo || true,
      defaultDriver: null,
      dropoffDriver: null,
      customerAllJobsPage: props.customerAllJobsPage || false,
      isDownloadClick: false,
      sending_expenses: false,
    };
    this.getDefaultDriverJobA = this.getDefaultDriverJobA.bind(this);
    this.getDefaultDriverJobB = this.getDefaultDriverJobB.bind(this);
  }
  getWeatherValue(signatureObj) {
    if (!signatureObj || !signatureObj.weather) return '';
    const weather = signatureObj.weather;
    if (typeof weather === 'object' && weather !== null) {
      if (Array.isArray(weather)) return weather[0] || '';
      if (weather.values && Array.isArray(weather.values)) return weather.values[0] || '';
      return weather.value || '';
    }
    return weather;
  }
  componentDidMount() {
  }
  sendMultipleExpenseMailToPeople(jobid) {
    this.setState({ sending_expenses: true })
    return fetch('/api/v1/portal/jobs/' + jobid + '/send-multiple-expense-mail-to-people',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        response.json().then(data => {
          alert(data.msg);
        });
      } else {
        let res = response.json();
        res.then((resJson) => {
          //alert(resJson);
          alert('There is issue with some data of jobs please check . . .');
        });
      }
    }).catch((error) => {
      alert('Unable to sent mail..' + error);
    }).finally(() => {
      this.setState({ sending_expenses: false });
    });
  }
  getDefaultDriverJobA(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/" + jobId,
      data: { api_token: window.api_token },
      cache: false
    })
      .done(function (defaultDriverJson) {
        if (defaultDriverJson != null) {
          that.setState({ defaultDriver: defaultDriverJson.first_name + ' ' + defaultDriverJson.last_name });
        } else {
          let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ?
            this.state.data.driver.user.first_name + ' ' + this.state.data.driver.user.last_name : null;
          that.setState({ defaultDriver: defaultDriver });
        }
      });
  }
  getDefaultDriverJobB(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/" + jobId,
      data: { api_token: window.api_token },
      cache: false
    })
      .done(function (defaultDriverJson) {
        if (defaultDriverJson != null) {
          that.setState({ dropoffDriver: defaultDriverJson.first_name + ' ' + defaultDriverJson.last_name });
        } else {
          let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ?
            this.state.data.driver.user.first_name + ' ' + this.state.data.driver.user.last_name : null;
          that.setState({ dropoffDriver: defaultDriver });
        }
      });
  }
  handleOnlyPickupAppraisal(multi_array, search_key, parent = '') {
    if (multi_array != null) {
      Object.keys(multi_array).forEach((key, index) => {
        if (typeof multi_array[key] == 'object') {
          if (search_key == key) {
            pickup[parent] = multi_array[key];
          } else {
            this.handleOnlyPickupAppraisal(multi_array[key], search_key, key);
          }
        }
      });
    }
    return pickup;
  }
  handleOnlyDropoffAppraisal(multi_array, search_key, parent = '') {
    if (multi_array != null) {
      Object.keys(multi_array).forEach((key, index) => {
        if (typeof multi_array[key] == 'object') {
          if (search_key == key) {
            dropoff[parent] = multi_array[key];
          } else {
            this.handleOnlyDropoffAppraisal(multi_array[key], search_key, key);
          }
        }
      });
    }
    return dropoff;
  }
  diff(obj1, obj2, exclude) {
    let r = {};

    if (!exclude) exclude = [];

    for (let prop in obj1) {
      if (Object.keys(obj1).length > 0 && obj1.hasOwnProperty(prop) && prop != '__proto__') {
        if (exclude.indexOf(obj1[prop]) == -1) {
          if (Object.keys(obj2).length > 0 !== null && !obj2.hasOwnProperty(prop)) r[prop] = obj1[prop];
          else if (obj1[prop] === Object(obj1[prop])) {
            if (obj1[prop] !== null && obj2[prop] !== null) {
              let difference = this.diff(obj1[prop], obj2[prop]);
              if (Object.keys(difference).length > 0) r[prop] = difference;
            }
          }

          else if (obj1[prop] !== obj2[prop]) {
            if (obj1[prop] === undefined)
              r[prop] = 'undefined';
            if (obj1[prop] === null)
              r[prop] = null;
            else if (typeof obj1[prop] === 'function')
              r[prop] = 'function';
            else if (typeof obj1[prop] === 'object')
              r[prop] = 'object';
            else
              r[prop] = obj1[prop];
          }
        }
      }
    }

    return r;
  }
  handleOnlyPickupAppraisalPath(arr, path = null) {
    let nextpath = "";
    if (typeof arr == 'object') {
      let current = [];
      Object.keys(arr).forEach((key, index) => {
        if (typeof arr[key] == 'object') {
          nextpath = (path == null) ? (key + ':') : (path + key + ':');
          if (arr[key] !== null) {
            current.push(this.handleOnlyPickupAppraisalPath(arr[key], nextpath));
          }
        } else {
          let keyval = path + key;
          pickupAppraisalPath[keyval] = arr[key];

        }
      });
      return pickupAppraisalPath;
    } else {
      return false;
    }
  }
  handleOnlyDropoffAppraisalPath(arr, path = null) {
    let nextpath = "";
    if (typeof arr == 'object') {
      let current = [];
      Object.keys(arr).forEach((key, index) => {
        if (typeof arr[key] == 'object') {
          nextpath = (path == null) ? (key + ':') : (path + key + ':');
          if (arr[key] !== null) {
            current.push(this.handleOnlyDropoffAppraisalPath(arr[key], nextpath));
          }
        } else {
          let keyval = path + key;
          dropoffAppraisalPath[keyval] = arr[key];

        }
      });
      return dropoffAppraisalPath;
    } else {
      return false;
    }
  }
  approveAppraisal(e, type) {
    return fetch('/api/v1/portal/jobs/' + this.state.data.id + '/approve-appraisal/' + type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Job appraisal is approved');
      } else {
        alert('Something went wrong..');
      }
    }).catch((error) => {
      alert('Something went wrong..');
    });
  }
  unapproveAppraisal(e, type) {
    return fetch('/api/v1/portal/jobs/' + this.state.data.id + '/un-approve-appraisal/' + type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Job appraisal is unapproved');
      } else {
        alert('Something went wrong..');
      }
    }).catch((error) => {
      alert('Something went wrong..');
    });
  }
  sendAppraisalPdfMailToCustomer(e, type) {
    return fetch('/api/v1/portal/jobs/' + this.state.data.id + '/send-appraisal-pdf-mail-to-customer/' + type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Mail sent to customer...');
      } else {
        let res = response.json();
        res.then((resJson) => {
          //alert(resJson);
          alert('There is issue with some data of jobs please check . . .');
        });
        // alert('Unable to sent mail..');
      }
    }).catch((error) => {
      alert('Unable to sent mail..' + error);
    });
  }
  handleCheckDiffAppraisals() {
    let infoModal = $('#infomodal');
    document.querySelector('#infomodallabel').innerHTML = 'Appraisals Difference';

    /********************* Only work for React *******************************************/
    let appraisal_data = this.state.appraisal_data;
    let jobId = this.state.data.id;
    appraisal_data = JSON.stringify(appraisal_data);
    appraisal_data = JSON.parse(appraisal_data);

    let pickupAppraisal = this.handleOnlyPickupAppraisal(appraisal_data, 'pickup');
    let dropoffAppraisal = this.handleOnlyDropoffAppraisal(appraisal_data, 'dropoff');
    let outputDiff = [];
    outputDiff['pickup'] = this.diff(pickupAppraisal, dropoffAppraisal);
    outputDiff['dropoff'] = this.diff(dropoffAppraisal, pickupAppraisal);

    let appraisalPickRes = this.handleOnlyPickupAppraisalPath(outputDiff['pickup']);
    let appraisalDropoffRes = this.handleOnlyDropoffAppraisalPath(outputDiff['dropoff']);
    /********************* Only work for React *******************************************/
    if (appraisalPickRes != null || appraisalPickRes != "" && appraisalDropoffRes != null || appraisalDropoffRes != "") {
      let appraisalDiff = Object.keys(appraisalPickRes).map((key) => {
        if (appraisalPickRes[key] !== undefined && appraisalDropoffRes[key] !== undefined) {
          let tdPickVal = "";
          let tdDropoffVal = "";
          let imgsrcP = "";
          let imgsrcD = "";

          if (key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_image_url/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)) {
            if (key.match(/uploadcare_image_urls/g)) {
              imgsrcP = appraisalPickRes[key];
            } else if (key.match(/uploadcare_image_url/g)) {
              imgsrcP = appraisalPickRes[key];
            } else if (key.match(/uploadcare_signature_image/g)) {
              imgsrcP = appraisalPickRes[key];
            } else {
              imgsrcP = '/storage/images/jobs/' + jobId + '/appraisal_images/' + appraisalPickRes[key];
            }
            tdPickVal = '<a href="' + imgsrcP + '" target="_blank"><img src=' + imgsrcP + ' class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/appraisal-placeholder-305_228.png\';"></a>';
          } else {
            tdPickVal = appraisalPickRes[key];
          }
          if (key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_image_url/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)) {
            if (key.match(/uploadcare_image_urls/g)) {
              imgsrcD = appraisalDropoffRes[key];
            } else if (key.match(/uploadcare_image_url/g)) {
              imgsrcD = appraisalDropoffRes[key];
            } else if (key.match(/uploadcare_signature_image/g)) {
              imgsrcD = appraisalDropoffRes[key];
            } else {
              imgsrcD = '/storage/images/jobs/' + jobId + '/appraisal_images/' + appraisalDropoffRes[key];
            }
            tdDropoffVal = '<a href="' + imgsrcD + '" target="_blank"><img src=' + imgsrcD + ' class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/appraisal-placeholder-305_228.png\';"></a>';
          } else {
            tdDropoffVal = appraisalDropoffRes[key];
          }

          let resKey = key.replace(/_/g, ' ').replace(/:0/g, ' ').replace(/:/g, ' ').replace(/entry/g, ' ').replace(/values/g, ' ');
          if (!resKey.match(/label/g)) {
            let html = '<tr><td><b>' + resKey + '</b></td><td>' + tdPickVal + '</td>';
            html += '<td>' + tdDropoffVal + '</td></tr>';
            return html;
          }
        }
      });

      let appraisalDifferences = '<table class="appraisalDiffDataTBL" >\n\
                            <thead>\n\
                                <th>DETAILS</th>\n\
                                <th>PICKUP</th>\n\
                                <th>DROPOFF</th>\n\
                            </thead>\n\
                            <tbody>'+ appraisalDiff + '</tbody>\n\
                        </table>';

      appraisalDifferences = appraisalDifferences.replace(/\,/g, "");
      document.querySelector('#infomodal .modal-body').innerHTML = appraisalDifferences;
    } else {
      document.querySelector('#infomodal .modal-body').innerHTML = 'No matches found!';
    }
    infoModal.modal();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      isLoadingAppraisalInfo: nextProps.isLoadingAppraisalInfo,
      appraisal_data: nextProps.appraisal_data,
      defaultDriver: (this.state.data.driver_id !== null && this.state.data.driver !== null) ?
        this.state.data.driver.user.first_name + ' ' + this.state.data.driver.user.last_name : null,
      dropoffDriver: (this.state.data.driver_id !== null && this.state.data.driver !== null) ?
        this.state.data.driver.user.first_name + ' ' + this.state.data.driver.user.last_name : null
    });
    if (nextProps.data.has_split_jobs == 1) {
      this.getDefaultDriverJobA(this.state.data.split_child_a_id);
      this.getDefaultDriverJobB(this.state.data.split_child_b_id);
    }
  }
  downloadAppraisalForJob(e, selector, time) {
    this.setState({ isDownloadClick: true })
    $('.pickDropAppraisal').addClass('buttonDisabled');
    let regNumber = ((this.state.data != null) && (this.state.data.vehicle) && (this.state.data.vehicle.registration_number)) ? this.state.data.vehicle.registration_number.replace(/[\/\\]/g, '-') : "";
    let pdfFileName = regNumber + '-appraisal-download-job-' + this.state.data.id + '-' + this.state.type + '-appraisal-' + time.toString() + '.pdf';
    return fetch('/api/v1/portal/appraisal-info/job/'
      + this.state.data.id + '/' + this.state.type + '/appraisal-download',
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      // return response.json();
      $('.pickDropAppraisal').removeClass('buttonDisabled');
      this.setState({ isDownloadClick: false })
      if (response.ok) {
        return response.blob();
      } else {
        throw new Error('Appraisal not found for this job.');
      }
    })
      .then((blob) => {
        // console.log(blob);
        this.setState({ isDownloading: false });
        this.setState({ isDownloadClick: false })
        $('.pickDropAppraisal').removeClass('buttonDisabled');
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = pdfFileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((error) => {
        $('.pickDropAppraisal').removeClass('buttonDisabled');
        this.setState({ isDownloadClick: false })
        alert(error);
      });
    /*console.log("in downloadAppraisalForJob")
    e.preventDefault();

    var element = document.getElementById(selector);
    var opt = {
      margin:       1,
      filename:     'myfile.pdf',
      image:        { type: 'jpeg', quality: 0.98 }, 
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
 
    // New Promise-based usage:
    html2pdf().from(element).set(opt).save();
    console.log("return before");
    return;
    console.log("return after");*/

    // html2canvas(document.getElementById(
    //   selector
    // ), {
    //   useCORS: true,
    //   dpi: 96,
    //   scale: 1
    // }).then(function(canvas) {
    //   makePdf(canvas);
    // });
    // let regNumber = (this.state.data != null) ? this.state.data.vehicle.registration_number : "";
    // let makePdf = function(canvas) {
    //   let appraisalImageForPdf = canvas.toDataURL("image/png"),
    //     position = 0,
    //     imageWidth = 210,
    //     imageHeight = canvas.height * imageWidth / canvas.width,
    //     pageHeight = 295,
    //     heightLeft = imageHeight,
    //     pdf = new jsPDF('p', 'mm');
    //   pdf.addImage(
    //     appraisalImageForPdf,
    //     'PNG',
    //     0,
    //     position,
    //     imageWidth,
    //     imageHeight,
    //     undefined,
    //     'slow'
    //   );
    //   heightLeft -= pageHeight;
    //   while (heightLeft >= 0) {
    //     position = heightLeft - imageHeight;
    //     pdf.addPage();
    //     pdf.addImage(
    //       appraisalImageForPdf,
    //       'PNG',
    //       0,
    //       position,
    //       imageWidth,
    //       imageHeight,
    //       undefined,
    //       'slow'
    //     );
    //     heightLeft -= pageHeight;
    //   }
    //   alert('PDF Generated!');
    //   pdf.save(
    //     regNumber+'-appraisal-download-'+
    //     selector+
    //     '-'+
    //     time.toString()+
    //     '.pdf'
    //   );
    // }
  }
  renderManualAppraisalVehiclePhotos(appraisal, type) {
    let ii = 0,
      ManualAppraisalVehiclePhotos = [];

    if (appraisal.manual_appraisal &&
      appraisal.manual_appraisal[type] &&
      appraisal.manual_appraisal[type].vehicle_info &&
      appraisal.manual_appraisal[type].vehicle_info.photo_names &&
      appraisal.manual_appraisal[type].vehicle_info.photo_names.length > 0) {
      let jobId = this.state.data.id;
      /* use first child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
        jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
      appraisal.manual_appraisal[type].vehicle_info.photo_names.forEach(function (i) {
        ii++;
        ManualAppraisalVehiclePhotos.push(
          (window.zoomImageForSpecificUser ? (
            <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}

              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-vehicle-photos-' + ii + _.random(3)} />) : (
            <img style={{ width: "100%" }}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-vehicle-photos-' + ii + _.random(3)}
            />
          )
          )
        );
      });
    }
    return (
      <div className="appraisal-images-container">{ManualAppraisalVehiclePhotos}</div>
    )
  }
  renderManualAppraisalVehicleInfoLine(info) {
    if (!info || !info.label || !info.values) {
      return null;
    }
    if ((info.label.toLowerCase() == "uploadcare photos") && info.values.length > 0) {
      let additionalImages = [];
      let jobId = this.state.data.id;
      /* use first child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && this.state.type == 'pickup') {
        jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && this.state.type == 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
      info.values.forEach(function (i, index) {
        additionalImages.push(
          (window.zoomImageForSpecificUser ? (
            <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} className="img-responsive"
              src={i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />) : (
            <img className="img-responsive" style={{ width: "100%" }}
              src={i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />)
          )
        );
      });

      return (
        <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
          <div className="appraisal-vehicle-info-line-label">Additional Images</div>
          <div className="appraisal-vehicle-info-line-value additional-images-block">{additionalImages}</div>
        </div>
      )
    } else if ((info.label.toLowerCase() == "v5 registration document") && info.values.length > 0 && arguments[1]) {
      let additionalImages = [];
      let jobId = this.state.data.id;
      if (typeof this.state.appraisal_data == "object" && "paperwork" in this.state.appraisal_data) {
        if (this.state.appraisal_data.paperwork && "uploadcare_image_urls" in this.state.appraisal_data.paperwork) {
          this.state.appraisal_data.paperwork.uploadcare_image_urls.forEach(function (i, index) {
            additionalImages.push(
              (window.zoomImageForSpecificUser ? (
                <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} className="img-responsive"
                  src={i}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                  }}
                  key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />) : (
                <img className="img-responsive" style={{ width: "100%" }}
                  src={i}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                  }}
                  key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />)
              )
            );
          });
        }
      }

      return (
        <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
          <div className="appraisal-vehicle-info-line-label">V5 and Keys</div>
          <div className="appraisal-vehicle-info-line-value additional-images-block">{additionalImages}</div>
        </div>
      )
    } else {
      let additionalImages = [];
      let infoLineImage = [];
      let jobId = this.state.data.id;
      if (info.label == "UploadCare Photos") {
        /* use first child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && this.state.type == 'pickup') {
          jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && this.state.type == 'dropoff') {
          jobId = this.state.data.split_child_b_id;
        }
        info.values.forEach(function (i, index) {
          additionalImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} className="img-responsive"
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />) : (
              <img className="img-responsive" style={{ width: "100%" }}
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />)
            )
          );
        });
      }

      if (info.photo_names && info.uploadcare_image_urls) {
        info.uploadcare_image_urls.forEach(function (i, index) {
          infoLineImage.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} className="img-responsive"
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />) : (
              <img className="img-responsive" style={{ width: "100%" }}
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-additional-photos-' + index + _.random(3)} />)
            )
          );
        });
      }

      let bgColor = (info.label.toLowerCase() == 'notes' && (info.values[0] !== null)) ? 'redalert' : '';
      return (
        <div className={bgColor + " appraisal-vehicle-info-line col-md-4 col-sm-12"}>
          <div className="appraisal-vehicle-info-line-label">{info.label}</div>
          <div className="appraisal-vehicle-info-line-value">
            {(info.label == "UploadCare Photos") ?
              additionalImages
              :
              info.values[0]}
          </div>
          {infoLineImage}
        </div>
      )
    }
  }
  renderManualAppraisalVehicleInfo(appraisal, type) {
    if (appraisal.manual_appraisal[type].vehicle_info) {
      if (this.state.data.manual_appraisal_required === 1 &&
        appraisal.manual_appraisal) {
        if (this.state.data.vehicle.type === 'car') {
          return (
            <div>
              <div className="appraisal-vehicle-info-line-container row">
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.aerial
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.adas_warning_light
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.is_camera_setup_dashboard
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.clean_exterior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.handbook
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.head_rests
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.inflation_kit
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.interior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_keys
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.service_book
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.spare_wheel
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tread_depth
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.visibility
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.weather
                )}

                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.notes
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.v5_registration_document
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.uploadcare_image_urls
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.does_charging_cable_attached
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.v5_registration_document, true
                )}
              </div>
              {this.renderManualAppraisalVehiclePhotos(appraisal, type)}
            </div>
          );
        }

        if (this.state.data.vehicle.type === 'van') {
          return (
            <div>
              <div className="appraisal-vehicle-info-line-container row">
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.aerial
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.adas_warning_light
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.is_camera_setup_dashboard
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.clean_exterior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.handbook
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.head_rests
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.interior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.inflation_kit
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tread_depth
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_keys
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.service_book
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.spare_wheel
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.visibility
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.weather
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.notes
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.v5_registration_document
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.uploadcare_image_urls
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.does_charging_cable_attached
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.v5_registration_document, true
                )}
              </div>
              {
                this.renderManualAppraisalVehiclePhotos(
                  appraisal,
                  type
                )
              }
            </div>
          );
        }
      }
      else {
        return <div>Manual Appraisal not required</div>
      }
    }
  }
  renderManualAppraisalVehiclePartLine(part, isSingleValue = false) {
    let ii = 0, VehiclePartImages = [], VehiclePartDamages = [];
    let type = this.state.type;
    if (!part) {
      return false;
    }
    let keyPart = part.label.replace(/\s+/g, '-').toLowerCase();
    if (part && part.uploadcare_image_urls && part.uploadcare_image_urls.length > 0) {
      if (part.uploadcare_image_urls[0].includes("https://")) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        part.uploadcare_image_urls.forEach(function (i) {
          ii++
          VehiclePartImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}

                key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
            ) : (
              <img style={{ width: "100%" }}
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
            )
            ));
        });
      } else if (part && part.photo_names && part.photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        /* use first child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
          jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
          jobId = this.state.data.split_child_b_id;
        }
        part.photo_names.forEach(function (i) {
          ii++;
          VehiclePartImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900}
                src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}

                key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
            ) : (
              <img style={{ width: "100%" }}
                src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
            ))
          );
        });
      }
    } else if (part && part.photo_names && part.photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
      /* use first child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
        jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
      part.photo_names.forEach(function (i) {
        ii++;
        VehiclePartImages.push(
          (window.zoomImageForSpecificUser ? (
            <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}

              key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
          ) : (
            <img style={{ width: "100%" }}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
          ))
        );
      });
    } else if (isSingleValue == true && part && part.uploadcare_image_url && part.uploadcare_image_url != null) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
      VehiclePartImages.push(
        (window.zoomImageForSpecificUser ? (
          <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={part.uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}

            key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
        ) : (
          <img style={{ width: "100%" }}
            src={part.uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            key={'job-' + jobId + '-part-' + ii + '-' + keyPart} />
        ))
      );
    }

    if (part && part.damages && part.damages.values &&
      part.damages.values.length > 0) {
      let jobId = this.state.data.id;
      part.damages.values.forEach(function (i) {
        ii++;
        VehiclePartDamages.push(
          <div key={'job-' + jobId + '-damage-' + ii + '-' + keyPart}
            className="vehicle-damage-label">{i}</div>
        );
      });
    }

    const capitalize = (text) =>
      text ? text.charAt(0).toUpperCase() + text.slice(1) : '';

    return (
      <div className="appraisal-vehicle-part-line col-md-6 col-sm-12">

        {/* Inline row */}
        <div className='pt-2' style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>

          {/* Label */}
          <span>
            <strong>{capitalize(part.label)}</strong>
          </span>

          {/* Damages */}
          {ii > 0 && (
            <span>
              <strong>Damages:</strong> {VehiclePartDamages}
            </span>
          )}

          {/* Notes (only if exists) */}
          {part?.notes && (
            <span>
              <strong>Note:</strong> {capitalize(part.notes)}
            </span>
          )}

        </div>

        {/* Images below */}
        <div className="appraisal-vehicle-part-line-images">
          {VehiclePartImages}
        </div>
      </div>
    );
  }


  renderNewKeysAboveMileage(part) {
    let jobId = this.state.data.id;

    if (
      this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null
    ) {
      jobId = this.state.data.subcontracted_job_id;
    }

    //  Step 1: collect all images
    let allImages = [];

    if (part?.uploadcare_image_url) {
      allImages.push(part.uploadcare_image_url);
    }

    if (part?.uploadcare_image_urls?.length > 0) {
      allImages = allImages.concat(part.uploadcare_image_urls);
    }

    if (part?.images?.length > 0) {
      part.images.forEach((img) => {
        if (img?.uploadcare_image_url) {
          allImages.push(img.uploadcare_image_url);
        }
      });
    }

    //  Step 2: remove invalid images
    allImages = allImages.filter(isValidImageUrl);

    // Step 3: remove duplicates
    allImages = [...new Set(allImages)];

    //  Step 4: empty state
    if (allImages.length === 0) {
      return (
        <div className="appraisal-mileage-images-container">
        </div>
      );
    }

    //  Step 5: render
    const VehiclePartImages = allImages.map((src, i) =>
      window.zoomImageForSpecificUser ? (
        <ZoomebleImage
          key={`job-${jobId}-img-${i}`}
          zoom={2}
          zoomWidth={900}
          zoomHeight={900}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
        />
      ) : (
        <img style={{ margin: '5px', width: '650px' }}
          key={`job-${jobId}-img-${i}`}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
        />
      )
    );

    return (
      <div className="appraisal-mileage-images-container">
        {VehiclePartImages}
      </div>
    );
  }

  renderManualAppraisalVehicleParts(appraisal, type) {
    if (appraisal.manual_appraisal[type].vehicle_parts) {
      if (this.state.data.manual_appraisal_required === 1 &&
        appraisal.manual_appraisal &&
        appraisal.manual_appraisal[type]) {

        if (this.state.data.vehicle.type === 'car') {
          return (
            <div className="appraisal-vehicle-part-line-container row">
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.driver_side_rear_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_light_driver
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_light_passenger
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.passenger_side_rear_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.bonnet
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.boot
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.driver_side_front_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.passenger_side_front_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.inside
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.rear_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.roof
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.windscreen
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.chassis_number`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.interior_front`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.interior_back`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.inflation_kit`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.number_of_keys`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.parcel_shelf`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.spare_wheel`)
              )}
            </div>
          );
        }

        if (this.state.data.vehicle.type === 'van') {
          return (
            <div className="appraisal-vehicle-part-line-container row">
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.bonnet
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.driver_side_front_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.driver_side_rear_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_side_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_side
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.inside
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_side
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_side_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.passenger_side_front_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.passenger_side_rear_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.slide_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.tail_light_driver
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.tail_light_passenger
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.windscreen
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.chassis_number`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.interior_front`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.interior_back`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.inflation_kit`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.number_of_keys`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.parcel_shelf`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.spare_wheel`)
              )}

              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.back_passenger_panel`)
              )}
              {this.renderManualAppraisalVehiclePartLine(
                _.get(appraisal, `manual_appraisal.${type}.vehicle_parts.boot`)
              )}

            </div>
          );
        }
      }
      else {
        return (<div>Manual Appraisal not required</div>)
      }
    }
  }
  hasDamages = (part) => {
    return part?.damages?.values?.length > 0;
  };
  renderManualAppraisalVehiclePartsV2(appraisal, type) {
    type = (type == 'pickup') ? 'vehicle_parts_pickup' : 'vehicle_parts_dropoff';
    if (appraisal.vehicle_parts[type]) {
      if (this.state.data.manual_appraisal_required === 1 &&
        appraisal.vehicle_parts &&
        appraisal.vehicle_parts[type]) {
        const parts = appraisal.vehicle_parts[type];
        if (this.state.data.vehicle.type === 'car') {
          return (
            <div className="appraisal-vehicle-part-line-container row">
              {this.hasDamages(parts.back_bumper) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_bumper)
              }

              {this.hasDamages(parts.back_driver_alloy) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_driver_alloy)
              }

              {this.hasDamages(parts.back_driver_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_driver_door)
              }

              {this.hasDamages(parts.driver_side_back_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_back_door)
              }

              {this.hasDamages(parts.back_driver_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_driver_panel)
              }

              {this.hasDamages(parts.driver_side_rear_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_rear_panel)
              }

              {this.hasDamages(parts.driver_side_back_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_back_panel)
              }

              {this.hasDamages(parts.back_driver_tyre) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_driver_tyre)
              }

              {this.hasDamages(parts.back_driver_window) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_driver_window)
              }

              {this.hasDamages(parts.back_light_driver) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_light_driver)
              }

              {this.hasDamages(parts.back_light_passenger) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_light_passenger)
              }

              {this.hasDamages(parts.back_passenger_alloy) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_passenger_alloy)
              }

              {this.hasDamages(parts.back_passenger_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_passenger_door)
              }

              {this.hasDamages(parts.back_passenger_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_passenger_panel)
              }

              {this.hasDamages(parts.passenger_side_rear_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_side_rear_panel)
              }

              {this.hasDamages(parts.back_passenger_tyre) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_passenger_tyre)
              }

              {this.hasDamages(parts.back_passenger_window) &&
                this.renderManualAppraisalVehiclePartLine(parts.back_passenger_window)
              }

              {this.hasDamages(parts.bonnet) &&
                this.renderManualAppraisalVehiclePartLine(parts.bonnet)
              }

              {this.hasDamages(parts.rear_windshield) &&
                this.renderManualAppraisalVehiclePartLine(parts.rear_windshield)
              }

              {this.hasDamages(parts.boot) &&
                this.renderManualAppraisalVehiclePartLine(parts.boot)
              }

              {this.hasDamages(parts.driver_head_light) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_head_light)
              }

              {this.hasDamages(parts.driver_wing_mirror) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_wing_mirror)
              }

              {this.hasDamages(parts.front_bumper) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_bumper)
              }

              {this.hasDamages(parts.front_driver_alloy) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_driver_alloy)
              }

              {this.hasDamages(parts.front_driver_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_driver_door)
              }

              {this.hasDamages(parts.driver_side_front_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_front_door)
              }

              {this.hasDamages(parts.front_driver_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_driver_panel)
              }

              {this.hasDamages(parts.driver_side_front_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_front_panel)
              }

              {this.hasDamages(parts.front_driver_tyre) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_driver_tyre)
              }

              {this.hasDamages(parts.front_driver_window) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_driver_window)
              }

              {this.hasDamages(parts.front_passenger_alloy) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_passenger_alloy)
              }

              {this.hasDamages(parts.front_passenger_door) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_passenger_door)
              }

              {this.hasDamages(parts.front_passenger_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_passenger_panel)
              }

              {this.hasDamages(parts.passenger_side_front_panel) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_side_front_panel)
              }

              {this.hasDamages(parts.front_passenger_tyre) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_passenger_tyre)
              }

              {this.hasDamages(parts.front_passenger_window) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_passenger_window)
              }

              {this.hasDamages(parts.inside) &&
                this.renderManualAppraisalVehiclePartLine(parts.inside)
              }

              {this.hasDamages(parts.passenger_head_light) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_head_light)
              }

              {this.hasDamages(parts.passenger_wing_mirror) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_wing_mirror)
              }

              {this.hasDamages(parts.rear_window) &&
                this.renderManualAppraisalVehiclePartLine(parts.rear_window)
              }

              {this.hasDamages(parts.roof) &&
                this.renderManualAppraisalVehiclePartLine(parts.roof)
              }

              {this.hasDamages(parts.windscreen) &&
                this.renderManualAppraisalVehiclePartLine(parts.windscreen)
              }

              {this.hasDamages(parts.tail_light_driver) &&
                this.renderManualAppraisalVehiclePartLine(parts.tail_light_driver)
              }

              {this.hasDamages(parts.tail_light_passenger) &&
                this.renderManualAppraisalVehiclePartLine(parts.tail_light_passenger)
              }

              {this.hasDamages(parts.dashboard) &&
                this.renderManualAppraisalVehiclePartLine(parts.dashboard)
              }

              {this.hasDamages(parts.doorcard_front_drivers_side) &&
                this.renderManualAppraisalVehiclePartLine(parts.doorcard_front_drivers_side)
              }

              {this.hasDamages(parts.doorcard_front_passenger_side) &&
                this.renderManualAppraisalVehiclePartLine(parts.doorcard_front_passenger_side)
              }

              {this.hasDamages(parts.front_footwell) &&
                this.renderManualAppraisalVehiclePartLine(parts.front_footwell)
              }

              {this.hasDamages(parts.staring_wheel) &&
                this.renderManualAppraisalVehiclePartLine(parts.staring_wheel)
              }

              {this.hasDamages(parts.passenger_side_front_seat) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_side_front_seat)
              }

              {this.hasDamages(parts.driver_side_front_seat) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_front_seat)
              }

              {this.hasDamages(parts.doorcard_rear_drivers_side) &&
                this.renderManualAppraisalVehiclePartLine(parts.doorcard_rear_drivers_side)
              }

              {this.hasDamages(parts.doorcard_rear_passenger_side) &&
                this.renderManualAppraisalVehiclePartLine(parts.doorcard_rear_passenger_side)
              }

              {this.hasDamages(parts.passenger_footwell) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_footwell)
              }

              {this.hasDamages(parts.passenger_side_back_seat) &&
                this.renderManualAppraisalVehiclePartLine(parts.passenger_side_back_seat)
              }

              {this.hasDamages(parts.driver_side_back_seat) &&
                this.renderManualAppraisalVehiclePartLine(parts.driver_side_back_seat)
              }
            </div>
          );
        }

        if (this.state.data.vehicle.type === 'van') {
          return (
            <div className="appraisal-vehicle-part-line-container row">
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].back_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].bonnet
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_side_front_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_side_rear_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_side_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_side
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].driver_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].front_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].front_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].front_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].front_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].front_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].inside
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_side
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_side_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_side_front_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].passenger_side_rear_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].slide_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].tail_light_driver
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].tail_light_passenger
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.vehicle_parts[type].windscreen
              )}
            </div>
          );
        }
      }
      else {
        return (<div>Manual Appraisal not required</div>)
      }
    }
  }

  renderManualAppraisalMileageImages(appraisal, type) {
    let MileageImages = [];
    if (appraisal.mileage &&
      appraisal.mileage[type] &&
      appraisal.mileage[type].uploadcare_image_urls &&
      appraisal.mileage[type].uploadcare_image_urls.length > 0) {
      if (appraisal.mileage[type].uploadcare_image_urls[0].includes("https://")) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        appraisal.mileage[type].uploadcare_image_urls.forEach(function (i) {
          MileageImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
            ) : (
              <img style={{ width: "100%" }}
                src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
            ))
          );
        });
      } else if (appraisal.mileage &&
        appraisal.mileage[type] &&
        appraisal.mileage[type].photo_names &&
        appraisal.mileage[type].photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        /* use first child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
          jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
          jobId = this.state.data.split_child_b_id;
        }
        appraisal.mileage[type].photo_names.forEach(function (i) {
          MileageImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
            ) : (
              <img style={{ width: "100%" }}
                src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
            ))
          );
        });
      }
    }
    else if (appraisal.mileage &&
      appraisal.mileage[type] &&
      appraisal.mileage[type].photo_names &&
      appraisal.mileage[type].photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
      /* use first child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
        jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
      appraisal.mileage[type].photo_names.forEach(function (i) {
        MileageImages.push(
          (window.zoomImageForSpecificUser ? (
            <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
          ) : (
            <img style={{ width: "100%" }}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-mileage-' + i + _.random(3)} />
          ))
        );
      });
    }
    return (
      <div className="appraisal-mileage-images-container">{MileageImages}</div>
    )
  }

  renderManualAppraisalPetrolLevelImages(appraisal, type) {
    let PetrolLevelImages = [];
    if (appraisal.petrol_level &&
      appraisal.petrol_level[type] &&
      appraisal.petrol_level[type].uploadcare_image_urls &&
      appraisal.petrol_level[type].uploadcare_image_urls.length > 0) {
      if (appraisal.petrol_level[type].uploadcare_image_urls[0].includes("https://")) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        appraisal.petrol_level[type].uploadcare_image_urls.forEach(function (i) {
          PetrolLevelImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-petrol-' + i + _.random(3)} />) : (
              <img style={{ width: "100%" }}
                src={i}
                onError={(e) => { e.target.onerror = null; e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png" }}
                key={'job-' + jobId + '-petrol-' + i + _.random(3)} />))
          );
        });
      } else if (appraisal.petrol_level &&
        appraisal.petrol_level[type] &&
        appraisal.petrol_level[type].photo_names &&
        appraisal.petrol_level[type].photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        /* use first child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
          jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
          jobId = this.state.data.split_child_b_id;
        }
        appraisal.petrol_level[type].photo_names.forEach(function (i) {
          PetrolLevelImages.push(
            (window.zoomImageForSpecificUser ? (
              <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
                }}
                key={'job-' + jobId + '-petrol-' + i + _.random(3)} />) : (
              <img style={{ width: "100%" }}
                src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
                onError={(e) => { e.target.onerror = null; e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png" }}
                key={'job-' + jobId + '-petrol-' + i + _.random(3)} />))
          );
        });
      }
    } else if (appraisal.petrol_level &&
      appraisal.petrol_level[type] &&
      appraisal.petrol_level[type].photo_names &&
      appraisal.petrol_level[type].photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
      /* use first child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
        jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
      appraisal.petrol_level[type].photo_names.forEach(function (i) {
        PetrolLevelImages.push(
          (window.zoomImageForSpecificUser ? (
            <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              key={'job-' + jobId + '-petrol-' + i + _.random(3)} />) : (
            <img style={{ width: "100%" }}
              src={"/storage/images/jobs/" + jobId + "/appraisal_images/" + i}
              onError={(e) => { e.target.onerror = null; e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png" }}
              key={'job-' + jobId + '-petrol-' + i + _.random(3)} />))
        );
      });
    }
    return (
      <div className="appraisal-petrol-level-images-container">
        {PetrolLevelImages}
      </div>
    )
  }

  renderAppraisalFeedbackQuestions(appraisal, type) {
    let AppraisalFeedbackQuestionsBlock = [];
    if (!appraisal.customer_signatures) {
      appraisal.customer_signatures = appraisal.manual_appraisal.customer_signatures;
    }
    if (type === 'pickup') {
      if (appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.welldress && appraisal.customer_signatures.pickup.welldress.values) {
        if (appraisal.customer_signatures.pickup.welldress.label && appraisal.customer_signatures.pickup.welldress.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.welldress.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.welldress.values[0]}</div>
            </div>
          );
        }
      }
      if (appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.driverbehaviour && appraisal.customer_signatures.pickup.driverbehaviour.values) {
        if (appraisal.customer_signatures.pickup.driverbehaviour.label && appraisal.customer_signatures.pickup.driverbehaviour.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.driverbehaviour.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.driverbehaviour.values[0]}</div>
            </div>
          );
        }
      }
      if (appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.driverexperience && appraisal.customer_signatures.pickup.driverexperience.values) {
        if (appraisal.customer_signatures.pickup.driverexperience.label && appraisal.customer_signatures.pickup.driverexperience.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.driverexperience.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.driverexperience.values[0]}</div>
            </div>
          );
        }
      }
    } else if (type === 'dropoff') {
      if (appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.welldress && appraisal.customer_signatures.dropoff.welldress.values) {
        if (appraisal.customer_signatures.dropoff.welldress.label && appraisal.customer_signatures.dropoff.welldress.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.welldress.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.welldress.values[0]}</div>
            </div>
          );
        }
      }
      if (appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.driverbehaviour && appraisal.customer_signatures.dropoff.driverbehaviour.values) {
        if (appraisal.customer_signatures.dropoff.driverbehaviour.label && appraisal.customer_signatures.dropoff.driverbehaviour.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.driverbehaviour.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.driverbehaviour.values[0]}</div>
            </div>
          );
        }
      }
      if (appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.driverexperience && appraisal.customer_signatures.dropoff.driverexperience.values) {
        if (appraisal.customer_signatures.dropoff.driverexperience.label && appraisal.customer_signatures.dropoff.driverexperience.values !== null) {
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.driverexperience.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.driverexperience.values[0]}</div>
            </div>
          );
        }
      }
    }

    if (AppraisalFeedbackQuestionsBlock.length) {
      return (
        <div className="appraisal-feedback-question-container row">
          {AppraisalFeedbackQuestionsBlock}
        </div>
      )
    } else {
      return (
        <div className="appraisal-feedback-question-container row">
          No appraisal feedback found.
        </div>
      )
    }
  }

  renderAppraisalInfoBlock(type) {
    let appraisal = this.state.appraisal_data;
    let appraisalInfoBlock;
    let signatureBlock = [];
    let jobId = this.state.data.id;
    if (this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null) {
      jobId = this.state.data.subcontracted_job_id;
    }

    if (typeof appraisal == "object" && "customer_signatures" in appraisal) {
      if ((type === 'pickup') &&
        "pickup" in appraisal.customer_signatures) {
        let appraisalPickupSignatureImage;
        if (appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image) {
          if (appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://")) {
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                appraisal.customer_signatures[type].uploadcare_signature_image
              } className="job-customer-signature-image"
              key={_.random(3)} />;
          } else {

            /* use first child job ID for photo_name */
            if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
              jobId = this.state.data.split_child_a_id;
            }
            if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
              jobId = this.state.data.split_child_b_id;
            }
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                "/storage/images/jobs/" + jobId + "/signature_images/" +
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image"
              key={_.random(3)} />;
          }
        }
        else {

          /* use first child job ID for photo_name */
          if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
            jobId = this.state.data.split_child_a_id;
          }
          if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
            jobId = this.state.data.split_child_b_id;
          }
          appraisalPickupSignatureImage = <img
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            src={
              "/storage/images/jobs/" + jobId + "/signature_images/" +
              appraisal.customer_signatures[type].signature_image
            } className="job-customer-signature-image"
            key={_.random(3)} />;
        }
        signatureBlock.push(
          <div key={'job-' + jobId + '-' + type + '-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
              appraisal.customer_signatures[type].signed_by
            }<br />
            Time Signed: {
              moment(
                appraisal.customer_signatures[type].date_signed
              ).format(
                'ddd Do MMM YYYY - HH:mm:ss'
              ).toString()
            }<br />
            Weather: {
              this.getWeatherValue(appraisal.customer_signatures[type])
            }<br />
            Location:&nbsp;
            {this.state.data.pickup_address.house_number_or_name ?
              this.state.data.pickup_address.house_number_or_name +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_1 ?
              this.state.data.pickup_address.address_line_1 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_2 ?
              this.state.data.pickup_address.address_line_2 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_3 ?
              this.state.data.pickup_address.address_line_3 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.town_city ?
              this.state.data.pickup_address.town_city +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.county ?
              this.state.data.pickup_address.county +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.country ?
              this.state.data.pickup_address.country +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.postcode ?
              this.state.data.pickup_address.postcode +
              ' ' :
              ''
            }
            <br />
            {appraisalPickupSignatureImage}
          </div>
        );
      }
      else if ((type === 'dropoff') &&
        "dropoff" in appraisal.customer_signatures) {
        let appraisalDropoffSignatureImage;
        if (appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image) {
          if (appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://")) {
            appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                appraisal.customer_signatures[type].uploadcare_signature_image
              } className="job-customer-signature-image"
              key={_.random(3)} />;
          } else {

            /* use first child job ID for photo_name */
            if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
              jobId = this.state.data.split_child_a_id;
            }
            if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
              jobId = this.state.data.split_child_b_id;
            }
            appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                "/storage/images/jobs/" + jobId + "/signature_images/" +
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image"
              key={_.random(3)} />;
          }
        }
        else {

          /* use first child job ID for photo_name */
          if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
            jobId = this.state.data.split_child_a_id;
          }
          if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
            jobId = this.state.data.split_child_b_id;
          }
          appraisalDropoffSignatureImage = <img
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            src={
              "/storage/images/jobs/" + jobId + "/signature_images/" +
              appraisal.customer_signatures[type].signature_image
            } className="job-customer-signature-image"
            key={_.random(3)} />;
        }
        signatureBlock = (
          <div key={'job-' + jobId + '-' + type + '-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
              appraisal.customer_signatures[type].signed_by
            }<br />
            Time Signed: {
              moment(
                appraisal.customer_signatures[type].date_signed
              ).format(
                'ddd Do MMM YYYY - HH:mm:ss'
              ).toString()
            }<br />
            Weather: {
              this.getWeatherValue(appraisal.customer_signatures[type])
            }<br />
            Location:&nbsp;
            {
              this.state.data.dropoff_address.house_number_or_name ?
                this.state.data.dropoff_address.house_number_or_name +
                ', ' :
                ''
            }
            {this.state.data.dropoff_address.address_line_1 ?
              this.state.data.dropoff_address.address_line_1 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_2 ?
              this.state.data.dropoff_address.address_line_2 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_3 ?
              this.state.data.dropoff_address.address_line_3 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.town_city ?
              this.state.data.dropoff_address.town_city +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.county ?
              this.state.data.dropoff_address.county +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.country ?
              this.state.data.dropoff_address.country +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.postcode ?
              this.state.data.dropoff_address.postcode +
              ' ' :
              ''
            }
            <br />
            {appraisalDropoffSignatureImage}
          </div>
        );
      }
      else {
        signatureBlock.push(
          <div key={'job-' + jobId + '--signature'}>
            <h5>Signature - not collected yet</h5>
          </div>
        );
      }
    }
    else {
      signatureBlock.push(
        <div key={'job-' + jobId + '--signature'}>
          <h5>Signature - not collected yet</h5>
        </div>
      );
    }
    if (typeof appraisal == "object" && "number_plate" in appraisal) {
      let diffOfMiles = (appraisal.mileage && appraisal.mileage[type] && appraisal.mileage[type].entry) ? ((appraisal.mileage['dropoff'].entry) - (appraisal.mileage['pickup'].entry)) : 0;
      appraisalInfoBlock = (
        <div
          className="text-left"
          key={'appraisal-info-block-for-' + appraisal.id}>
          {this.state.type == 'dropoff' ?
            <div>
              <br />
              <h5>Difference between pick up and drop off miles:&nbsp;
                <strong>
                  {diffOfMiles}
                </strong>
              </h5>
            </div>
            : ""}
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              Driver Name: <strong>
                {(this.state.defaultDriver !== null && this.state.type == 'pickup') ?
                  <span>{this.state.defaultDriver}</span>
                  :
                  (this.state.dropoffDriver !== null && this.state.type == 'dropoff') ? <span>{this.state.dropoffDriver}</span> :
                    <span>No Driver</span>
                }
              </strong>
            </div>
            <div className="col-md-8 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  Customer Name:<br /><strong>
                    {this.state.data.customer.name}
                  </strong>
                </div>
                <div className="col-md-4">
                  Order Number:<br /><strong>
                    {this.state.data.customer_order_number}
                  </strong>
                </div>
                <div className="col-md-4">
                  Job Number:<br /><strong>
                    {this.state.data.customer_job_number}
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12">
              <h4>Notes</h4>
              {this.state.data.notes}
            </div>
          </div>
          <br />
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              <h4>Number Plate</h4>
              <strong>{((this.state.data) && (this.state.data.vehicle.registration_number)) ? this.state.data.vehicle.registration_number : ''}</strong>
              {(appraisal.number_plate &&
                appraisal.number_plate[type] &&
                appraisal.number_plate[type].entry) ?
                <h5>Entry:&nbsp;
                  <strong>
                    {appraisal.number_plate[type].entry}
                  </strong>
                </h5>
                :
                <h5>No entry.</h5>
              }
              <br />
              {this.renderManualAppraisalNumberPlateImages(appraisal, type)}
            </div>

            <div className="col-md-4">
              <h4>VIN</h4>
              <strong>{this.state.data.vehicle.vin_number}</strong>
              {(appraisal.vin &&
                appraisal.vin[type] &&
                appraisal.vin[type].entry) ?
                <h5>Entry:&nbsp;
                  <strong>
                    {appraisal.vin[type].entry}
                  </strong>
                </h5>
                :
                <h5>No entry.</h5>
              }
            </div>


            <div className="col-md-4">
              <h4>Warning Lights</h4>
              {(appraisal.warning_light &&
                appraisal.warning_light[type] &&
                appraisal.warning_light[type].value) ?
                <h5>Entry:
                  <strong>
                    {appraisal.warning_light[type].label}
                  </strong>:
                  {appraisal.warning_light[type].value}
                </h5>
                :
                <h5>Entry: <strong>No warning lights</strong></h5>
              }
              <br />
            </div>
          </div>

          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Rear</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].rear) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].rear) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Front</h4>
                </div>
              </div>

              {(appraisal.manual_appraisal[type].front) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].front) : null}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Driver Side</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].driver_side) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].driver_side) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Passenger Side</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].passenger_side) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].passenger_side) : null}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Mileage</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.mileage &&
                    appraisal.mileage[type] &&
                    appraisal.mileage[type].entry) ?
                    <h5><strong>{appraisal.mileage[type].entry}</strong></h5>
                    :
                    <h5>No entry.</h5>
                  }
                  <br />
                </div>
              </div>

              {this.renderManualAppraisalMileageImages(appraisal, type)}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Petrol Level</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.petrol_level &&
                    appraisal.petrol_level[type] &&
                    appraisal.petrol_level[type].entry) ?
                    <h5>About&nbsp;
                      <strong>
                        {appraisal.petrol_level[type].entry}%
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }<br />
                </div>
              </div>
              {this.renderManualAppraisalPetrolLevelImages(
                appraisal, type
              )}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Oil Level</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.oil_level &&
                    appraisal.oil_level[type] &&
                    appraisal.oil_level[type].entry) ?
                    <h5><strong>{appraisal.oil_level[type].entry}</strong></h5>
                    :
                    <h5>No entry.</h5>
                  }
                  <br />
                </div>
              </div>

              {this.renderManualAppraisalOilLevelImages(appraisal, type)}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Water Level</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.water_level &&
                    appraisal.water_level[type] &&
                    appraisal.water_level[type].entry) ?
                    <h5>About&nbsp;
                      <strong>
                        {appraisal.water_level[type].entry}
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }<br />
                </div>
              </div>
              {this.renderManualAppraisalWaterLevelImages(
                appraisal, type
              )}
            </div>
          </div>
          <hr />

          <h4 className="text-center">Manual Appraisal</h4>
          <h5>Vehicle Info</h5>
          {this.renderManualAppraisalVehicleInfo(appraisal, type)}
          <div>&nbsp;</div>
          <h5>Vehicle Parts</h5>
          {this.renderManualAppraisalVehicleParts(appraisal, type)}
          <hr />
          <h4 className="text-center">Appraisal Feedback</h4>
          {this.renderAppraisalFeedbackQuestions(appraisal, type)}
          <hr />
          <h4 className="text-center">Video Appraisal</h4>
          <div className="row">
            {this.renderVideoAppraisalBlock(appraisal, type)}
          </div>
          {signatureBlock}
        </div>
      );
    }
    else {
      appraisalInfoBlock = (
        <div className="row" key={'appraisal-info-block-for' + appraisal.id}>
          <div className="col-md-12">
            <p>
              <strong>
                No Appraisal Yet.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    return appraisalInfoBlock;
  }
  renderVideoAppraisalBlock(appraisal, type) {
    let videoBlock;
    videoBlock = [];
    let ii = 0;
    let jobId = this.state.data.id;
    if (this.state.data.video_appraisal_required === 1 &&
      appraisal.video_appraisal &&
      appraisal.video_appraisal[type]) {
      if (appraisal.video_appraisal[type].videos.length > 0) {
        appraisal.video_appraisal[type].videos.forEach(function (i) {
          ii++;
          videoBlock.push(
            <VimeoVideo key={'job-' + jobId + '-vimeo-' + ii} data={i} />
          );
        });
      }
      else {
        videoBlock = (
          <p><strong>No videos yet.</strong></p>
        );
      }
    }
    else {
      videoBlock = (<div>Video appraisal not required</div>);
    }
    return videoBlock;
  }

  renderManualAppraisalOilLevelImages(appraisal, type) {
    let OilLevelImages = [];

    const oilData = appraisal?.oil_level?.[type];

    // Resolve jobId
    let jobId = this.state.data.id;

    if (
      this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null
    ) {
      jobId = this.state.data.subcontracted_job_id;
    }

    if (this.state.data.has_split_jobs == 1) {
      if (type === 'pickup') {
        jobId = this.state.data.split_child_a_id;
      } else if (type === 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
    }

    let imageUrls = [];

    // Prefer uploadcare URLs
    if (
      oilData?.uploadcare_image_urls &&
      oilData.uploadcare_image_urls.length > 0 &&
      oilData.uploadcare_image_urls[0].includes("https://")
    ) {
      imageUrls = oilData.uploadcare_image_urls;
    }
    // Fallback to photo_names
    else if (oilData?.photo_names && oilData.photo_names.length > 0) {
      imageUrls = oilData.photo_names.map(
        (name) => `/storage/images/jobs/${jobId}/appraisal_images/${name}`
      );
    }

    //  Placeholder if no images
    if (!imageUrls || imageUrls.length === 0) {
      return (
        <div className="appraisal-oil-level-images-container">
          <img
            style={{ width: "100%" }}
            src="/images/placeholders/appraisal-placeholder-305_228.png"
            alt="placeholder"
          />
        </div>
      );
    }

    //  Render images
    OilLevelImages = imageUrls.map((src, i) =>
      window.zoomImageForSpecificUser ? (
        <ZoomebleImage
          zoom={2}
          zoomWidth={900}
          zoomHeight={900}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
          key={`job-${jobId}-oil-${i}`}
        />
      ) : (
        <img
          style={{ width: "100%" }}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
          key={`job-${jobId}-oil-${i}`}
        />
      )
    );

    return (
      <div className="appraisal-oil-level-images-container">
        {OilLevelImages}
      </div>
    );
  }


  renderManualAppraisalWaterLevelImages(appraisal, type) {
    const waterData = appraisal?.water_level?.[type];
    let jobId = this.state.data.id;
    if (
      this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null
    ) {
      jobId = this.state.data.subcontracted_job_id;
    }

    if (this.state.data.has_split_jobs == 1) {
      if (type === 'pickup') {
        jobId = this.state.data.split_child_a_id;
      } else if (type === 'dropoff') {
        jobId = this.state.data.split_child_b_id;
      }
    }

    let imageUrls = [];

    // Prefer uploadcare images
    if (
      waterData?.uploadcare_image_urls &&
      waterData.uploadcare_image_urls.length > 0 &&
      waterData.uploadcare_image_urls[0].includes("https://")
    ) {
      imageUrls = waterData.uploadcare_image_urls;
    }
    // Fallback to photo_names
    else if (waterData?.photo_names && waterData.photo_names.length > 0) {
      imageUrls = waterData.photo_names.map(
        (name) => `/storage/images/jobs/${jobId}/appraisal_images/${name}`
      );
    }

    // Placeholder if no images
    if (!imageUrls || imageUrls.length === 0) {
      return (
        <div className="appraisal-water-level-images-container">
          <img
            style={{ width: "100%" }}
            src="/images/placeholders/appraisal-placeholder-305_228.png"
            alt="placeholder"
          />
        </div>
      );
    }

    // Render images
    const WaterLevelImages = imageUrls.map((src, i) =>
      window.zoomImageForSpecificUser ? (
        <ZoomebleImage
          zoom={2}
          zoomWidth={900}
          zoomHeight={900}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
          key={`job-${jobId}-water-${i}`}
        />
      ) : (
        <img
          style={{ width: "100%" }}
          src={src}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
          key={`job-${jobId}-water-${i}`}
        />
      )
    );

    return (
      <div className="appraisal-water-level-images-container">
        {WaterLevelImages}
      </div>
    );
  }

  renderManualAppraisalNumberPlateImages(appraisal, type) {
    var NumberPlateImages = [];
    if ((appraisal.number_plate[type]) && (appraisal.number_plate[type].uploadcare_image_url)) {
      NumberPlateImages.push(
        (window.zoomImageForSpecificUser ? (
          <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={appraisal.number_plate[type].uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            key={_.random(3)}
          />) : (
          <img style={{ width: "100%" }}
            src={appraisal.number_plate[type].uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            key={_.random(3)} />))
      );
    }
    return (
      <div className="appraisal-oil-level-images-container">
        {NumberPlateImages}
      </div>
    )
  }
  renderManualAppraisalNumberPlateImagesV2(appraisal, type) {
    type = (type == 'pickup') ? 'number_plate_pickup' : 'number_plate_dropoff';
    var NumberPlateImages = [];
    if ((appraisal.number_plate[type]) && (appraisal.number_plate[type].uploadcare_image_url)) {
      NumberPlateImages.push(
        (window.zoomImageForSpecificUser ? (
          <ZoomebleImage zoom={2} zoomWidth={900} zoomHeight={900} src={appraisal.number_plate[type].uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            key={_.random(3)}
          />) : (
          <img style={{ width: "100%" }}
            src={appraisal.number_plate[type].uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            key={_.random(3)} />))
      );
    }
    return (
      <div className="appraisal-oil-level-images-container">
        {NumberPlateImages}
      </div>
    )
  }

  appraisalIsNotDoneFromDriverApp() {
    return this.state.data?.apprisal_required_from_driver_app === 0 || this.state.appraisal_data?.manual_appraisal === null;
  }

  renderAppraisalInfoBlockV2(type) {
    let appraisal = this.state.appraisal_data;
    let appraisalInfoBlock;
    let signatureBlock = [];
    let jobId = this.state.data.id;
    if (this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null) {
      jobId = this.state.data.subcontracted_job_id;
    }

    if (typeof appraisal == "object" && "customer_signatures" in appraisal) {
      let customer_signatures_type = (type == 'pickup') ? 'customer_signatures_pickup' : 'customer_signatures_dropoff';
      if ((customer_signatures_type === 'customer_signatures_pickup') &&
        "customer_signatures_pickup" in appraisal.customer_signatures) {
        let appraisalPickupSignatureImage;
        if (appraisal.customer_signatures && appraisal.customer_signatures[customer_signatures_type] && appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image) {
          if (appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image.includes("https://")) {
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image
              } className="job-customer-signature-image" key={_.random(3)} />;
          } else {

            /* use first child job ID for photo_name */
            if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
              jobId = this.state.data.split_child_a_id;
            }
            if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
              jobId = this.state.data.split_child_b_id;
            }
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                "/storage/images/jobs/" + jobId + "/signature_images/" +
                appraisal.customer_signatures[customer_signatures_type].signature_image
              } className="job-customer-signature-image"
              key={_.random(3)} />;
          }
        }
        else {

          /* use first child job ID for photo_name */
          if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
            jobId = this.state.data.split_child_a_id;
          }
          if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
            jobId = this.state.data.split_child_b_id;
          }
          appraisalPickupSignatureImage = <img
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            src={
              "/storage/images/jobs/" + jobId + "/signature_images/" +
              appraisal.customer_signatures[customer_signatures_type].signature_image
            } className="job-customer-signature-image" key={_.random(3)} />;
        }
        signatureBlock.push(
          <div key={'job-' + jobId + '-' + customer_signatures_type + '-signature'}>
            <h5>{customer_signatures_type == 'customer_signatures_pickup' ? 'Pickup' : 'Dropoff'} Signature</h5>
            Signed By: {
              appraisal.customer_signatures[customer_signatures_type].signed_by
            }
            <div className="row">
              <div className="col-12">
                {appraisalPickupSignatureImage}
              </div>
            </div>
            <br />
            Time Signed: {
              moment(
                appraisal.customer_signatures[customer_signatures_type].date_signed,
                'DD/MM/YYYY HH:mm'
              ).format(
                'ddd Do MMM YYYY - HH:mm'
              ).toString()
            }<br />
            Weather: {
              this.getWeatherValue(appraisal.customer_signatures[customer_signatures_type])
            }<br />
            Location:&nbsp;
            {this.state.data.pickup_address.house_number_or_name ?
              this.state.data.pickup_address.house_number_or_name +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_1 ?
              this.state.data.pickup_address.address_line_1 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_2 ?
              this.state.data.pickup_address.address_line_2 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_3 ?
              this.state.data.pickup_address.address_line_3 +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.town_city ?
              this.state.data.pickup_address.town_city +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.county ?
              this.state.data.pickup_address.county +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.country ?
              this.state.data.pickup_address.country +
              ', ' :
              ''
            }
            {this.state.data.pickup_address.postcode ?
              this.state.data.pickup_address.postcode +
              ' ' :
              ''
            }
            <hr />
            <div className="row">
              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_cutomer_id_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Customer ID Image</h5>
                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_cutomer_id_image
                      }
                      className="img-thumbnail"
                    />
                  </div>
                )}

              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_location_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Location Image</h5>
                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_location_image
                      }
                      className="img-thumbnail"
                    />
                  </div>
                )}

              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_vehicle_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Vehicle Image</h5>
                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_vehicle_image
                      }
                      className="img-thumbnail"
                    />
                  </div>
                )}
            </div>

            <hr />
            Additional Notes:&nbsp;
            {appraisal.customer_signatures[customer_signatures_type].additional_notes ?? ''}
          </div>
        );
      }
      else if ((customer_signatures_type === 'customer_signatures_dropoff') &&
        "customer_signatures_dropoff" in appraisal.customer_signatures) {
        let appraisalDropoffSignatureImage;
        if (appraisal.customer_signatures && appraisal.customer_signatures[customer_signatures_type] && appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image) {
          if (appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image.includes("https://")) {
            appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                appraisal.customer_signatures[customer_signatures_type].uploadcare_signature_image
              } className="job-customer-signature-image" key={_.random(3)} />;
          } else {

            /* use first child job ID for photo_name */
            if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
              jobId = this.state.data.split_child_a_id;
            }
            if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
              jobId = this.state.data.split_child_b_id;
            }
            appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
              }}
              src={
                "/storage/images/jobs/" + jobId + "/signature_images/" +
                appraisal.customer_signatures[customer_signatures_type].signature_image
              } className="job-customer-signature-image" key={_.random(3)} />;
          }
        }
        else {

          /* use first child job ID for photo_name */
          if (this.state.data.has_split_jobs == 1 && type == 'pickup') {
            jobId = this.state.data.split_child_a_id;
          }
          if (this.state.data.has_split_jobs == 1 && type == 'dropoff') {
            jobId = this.state.data.split_child_b_id;
          }
          appraisalDropoffSignatureImage = <img
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png"
            }}
            src={
              "/storage/images/jobs/" + jobId + "/signature_images/" +
              appraisal.customer_signatures[customer_signatures_type].signature_image
            } className="job-customer-signature-image" key={_.random(3)} />;
        }
        signatureBlock = (
          <div key={'job-' + jobId + '-' + customer_signatures_type + '-signature'}>
            <h5>{customer_signatures_type} Signature</h5>
            Signed By: {
              appraisal.customer_signatures[customer_signatures_type].signed_by
            }
            <div className="row">
              <div className="col-12">
                {appraisalDropoffSignatureImage}
              </div>
            </div>
            <br />
            Time Signed: {
              moment(
                appraisal.customer_signatures[customer_signatures_type].date_signed,
                'DD/MM/YYYY HH:mm'
              ).format(
                'ddd Do MMM YYYY - HH:mm'
              ).toString()
            }<br />
            Weather: {
              this.getWeatherValue(appraisal.customer_signatures[customer_signatures_type])
            }<br />
            Location:&nbsp;
            {
              this.state.data.dropoff_address.house_number_or_name ?
                this.state.data.dropoff_address.house_number_or_name +
                ', ' :
                ''
            }
            {this.state.data.dropoff_address.address_line_1 ?
              this.state.data.dropoff_address.address_line_1 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_2 ?
              this.state.data.dropoff_address.address_line_2 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_3 ?
              this.state.data.dropoff_address.address_line_3 +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.town_city ?
              this.state.data.dropoff_address.town_city +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.county ?
              this.state.data.dropoff_address.county +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.country ?
              this.state.data.dropoff_address.country +
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.postcode ?
              this.state.data.dropoff_address.postcode +
              ' ' :
              ''
            }
            <hr />
            <div className="row">
              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_cutomer_id_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Customer ID Image</h5>

                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_cutomer_id_image
                      }
                      className="img-thumbnail"
                      key={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_cutomer_id_image
                      }
                    />
                  </div>
                )}

              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_location_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Location Image</h5>

                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_location_image
                      }
                      className="img-thumbnail"
                    />
                  </div>
                )}

              {appraisal.customer_signatures?.[customer_signatures_type]
                ?.uploadcare_vehicle_image && (
                  <div className="col-12 col-md-4 mb-3">
                    <h5>Vehicle Image</h5>

                    <img
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/images/placeholders/appraisal-placeholder-305_228.png";
                      }}
                      src={
                        appraisal.customer_signatures[customer_signatures_type]
                          .uploadcare_vehicle_image
                      }
                      className="img-thumbnail"
                    />
                  </div>
                )}
            </div>
            <hr />
            Additional Notes:&nbsp;
            {appraisal.customer_signatures[customer_signatures_type].additional_notes ?? ''}
          </div>
        );
      }
      else {
        signatureBlock.push(
          <div key={'job-' + jobId + '--signature'}>
            <h5>Signature - not collected yet</h5>
          </div>
        );
      }
    }
    else {
      signatureBlock.push(
        <div key={'job-' + jobId + '--signature'}>
          <h5>Signature - not collected yet</h5>
        </div>
      );
    }

    const versionString = this.state.appraisal_data.appVersion;
    const version = versionString ? versionString.split(' ')[0] : "1.3.1";

    const compareVersions = (v1, v2) => {
      const a = v1.split('.').map(Number);
      const b = v2.split('.').map(Number);

      for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const diff = (a[i] || 0) - (b[i] || 0);
        if (diff !== 0) return diff;
      }
      return 0;
    };
    const shouldShow = compareVersions(version, "1.3.2") < 0;

    const frontInteriorType = type === 'pickup' ? 'front_interior_pickup' : 'front_interior_dropoff';
    const hornValue = appraisal?.front_interior?.[frontInteriorType]?.horn;
    const radioValue = appraisal?.front_interior?.[frontInteriorType]?.radio;
    const wiperValue = appraisal?.front_interior?.[frontInteriorType]?.wiper;
    const airconValue = appraisal?.front_interior?.[frontInteriorType]?.aircone;
    const windowsValue = appraisal?.front_interior?.[frontInteriorType]?.windows;
    const satNavValue = appraisal?.front_interior?.[frontInteriorType]?.sat_nav_disk_or_sd_card;
    const rearViewMirrorValue = appraisal?.front_interior?.[frontInteriorType]?.rear_view_mirror;
    const chargingCableValue = appraisal?.front_interior?.[frontInteriorType]?.charging_cable;

    const inflationkitType = type === 'pickup' ? 'inflation_kit_pickup' : 'inflation_kit_dropoff';
    const inflationKitValue = appraisal?.inflation_kit?.[inflationkitType]?.entry;

    const frontWindscreenType = type === 'pickup' ? 'pickup' : 'dropoff';
    const frontWindscreenKitValue = appraisal?.front_windscreen?.[frontWindscreenType]?.entry;

    const rearWindscreenType = type === 'pickup' ? 'pickup' : 'dropoff';
    const rearWindscreenKitValue = appraisal?.rear_windscreen?.[rearWindscreenType]?.entry;

    const spareWheelType = type === 'pickup' ? 'spare_wheel_pickup' : 'spare_wheel_dropoff';
    const spareWheelValue = appraisal?.spare_wheel?.[spareWheelType]?.entry;
    const jackValue = appraisal?.spare_wheel?.[spareWheelType]?.jack;
    const wrenchValue = appraisal?.spare_wheel?.[spareWheelType]?.wrench;
    const extensionBarValue = appraisal?.spare_wheel?.[spareWheelType]?.extension_bar;

    const lockingWheelNutType = type === 'pickup' ? 'pickup' : 'dropoff';
    const lockingWheelNutValue = appraisal?.locking_wheel_nut?.[lockingWheelNutType]?.entry;

    if (typeof appraisal == "object" && "number_plate" in appraisal) {
      let diffOfMiles = (appraisal.mileage && appraisal.mileage[type] && appraisal.mileage[type]?.entry) ? ((appraisal.mileage['dropoff']?.entry) - (appraisal.mileage['pickup']?.entry)) : 0;
      appraisalInfoBlock = (
        <div
          className="text-left"
          key={'appraisal-info-block-for-' + appraisal.id}>
          {this.state.type == 'dropoff' ?
            <div>
              <br />
              <h5>Difference between pick up and drop off miles:&nbsp;
                <strong>
                  {diffOfMiles}
                </strong>
              </h5>
            </div>
            : ""}
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              Driver Name: <strong>
                {(this.state.defaultDriver !== null && this.state.type == 'pickup') ?
                  <span>{this.state.defaultDriver}</span>
                  :
                  (this.state.dropoffDriver !== null && this.state.type == 'dropoff') ? <span>{this.state.dropoffDriver}</span> :
                    <span>No Driver</span>
                }
              </strong>
            </div>
            <div className="col-md-8 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  Customer Name:<br /><strong>
                    {this.state.data.customer.name}
                  </strong>
                </div>
                <div className="col-md-4">
                  Order Number:<br /><strong>
                    {this.state.data.customer_order_number}
                  </strong>
                </div>
                <div className="col-md-4">
                  Job Number:<br /><strong>
                    {this.state.data.customer_job_number}
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12">
              <h4>Notes</h4>
              {this.state.data.notes}
            </div>
          </div>
          <br />
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              <div className="row">
                <div className="col">
                  <h4>Number Plate</h4>
                  <strong>{((this.state.data) && (this.state.data.vehicle.registration_number)) ? this.state.data.vehicle.registration_number : ''}</strong>
                  {(appraisal.number_plate &&
                    appraisal?.number_plate[type] &&
                    appraisal?.number_plate[type].entry) ?
                    <h5>Entry:&nbsp;
                      <strong>
                        {appraisal.number_plate[type].entry}
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }
                </div>
                <div className="col">
                  <h4>VIN</h4>
                  <strong>{this.state.data.vehicle.vin_number}</strong>
                  {(appraisal.vin &&
                    appraisal.vin[type] &&
                    appraisal.vin[type].entry) ?
                    <h5>Entry:&nbsp;
                      <strong>
                        {appraisal.vin[type].entry}
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }
                </div>
              </div>

              <br />
              {this.renderManualAppraisalNumberPlateImagesV2(appraisal, type)}
            </div>
            <div className="col-md-4">
              <h4>Chassis Number</h4>
              {(appraisal.chassis_number &&
                appraisal.chassis_number[type] &&
                appraisal.chassis_number[type].entry) ?
                <h5>
                  Entry:&nbsp;
                  <strong>
                    {appraisal.chassis_number[type].entry}
                  </strong>
                </h5>
                :
                <h5>No entry.</h5>
              }
              <br />
              <br />
              {appraisal?.chassis_number[type] &&
                this.renderNewKeysAboveMileage(appraisal?.chassis_number[type])
              }
            </div>
            <div className="col-md-4">
              <h4>Warning Lights</h4>
              {(appraisal.warning_light &&
                appraisal.warning_light[type] &&
                appraisal.warning_light[type].value) ?
                <h5>Entry:
                  <strong>
                    {appraisal.warning_light[type].label}
                  </strong>:
                  {appraisal.warning_light[type].value}
                </h5>
                :
                <h5>Entry: <strong>No warning lights</strong></h5>
              }
              <br />
              <br />
              {appraisal?.chassis_number[type] &&
                this.renderNewKeysAboveMileage(appraisal?.warning_light[type])
              }
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Rear</h4>
                </div>
              </div>
              {(appraisal?.rear[type]) ? this.renderNewKeysAboveMileage(appraisal?.rear[type]) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Front</h4>
                </div>
              </div>

              {(appraisal?.front[type]) ? this.renderNewKeysAboveMileage(appraisal?.front[type]) : null}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Driver Side</h4>
                </div>
              </div>
              {(appraisal?.off_side[type]) ? this.renderNewKeysAboveMileage(appraisal?.off_side[type]) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Passenger Side</h4>
                </div>
              </div>
              {(appraisal?.near_side[type]) ? this.renderNewKeysAboveMileage(appraisal?.near_side[type]) : null}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Mileage</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.mileage &&
                    appraisal.mileage[type] &&
                    appraisal.mileage[type].entry) ?
                    <h5><strong>{appraisal.mileage[type].entry}</strong></h5>
                    :
                    <h5>No entry.</h5>
                  }
                  <br />
                </div>
              </div>

              {this.renderManualAppraisalMileageImages(appraisal, type)}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Petrol Level</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.petrol_level &&
                    appraisal.petrol_level[type] &&
                    appraisal.petrol_level[type].entry) ?
                    <h5>About&nbsp;
                      <strong>
                        {appraisal.petrol_level[type].entry}%
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }<br />
                </div>
              </div>
              {this.renderManualAppraisalPetrolLevelImages(
                appraisal, type
              )}
            </div>
          </div>
          <hr />
          {type === 'pickup' && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-6">
                      <h4>Oil Level</h4>
                    </div>
                    <div className="col-md-6">
                      {(appraisal.oil_level &&
                        appraisal.oil_level[type] &&
                        appraisal.oil_level[type].entry) ?
                        <h5><strong>{appraisal.oil_level[type].entry}</strong></h5>
                        :
                        <h5>No entry.</h5>
                      }
                      <br />
                    </div>
                  </div>

                  {this.renderManualAppraisalOilLevelImages(appraisal, type)}
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-6">
                      <h4>Water Level</h4>
                    </div>
                    <div className="col-md-6">
                      {(appraisal.water_level &&
                        appraisal.water_level[type] &&
                        appraisal.water_level[type].entry) ?
                        <h5>About&nbsp;
                          <strong>
                            {appraisal.water_level[type].entry}
                          </strong>
                        </h5>
                        :
                        <h5>No entry.</h5>
                      }<br />
                    </div>
                  </div>
                  {this.renderManualAppraisalWaterLevelImages(
                    appraisal, type
                  )}
                </div>
              </div>
              <hr />
            </>
          )}
          <div className="row">
            <div className="col-md-6">
              <h4>Offside Rear Tyre</h4>
              {(appraisal?.off_side_rear_tyre[type]) ? this.renderNewKeysAboveMileage(appraisal?.off_side_rear_tyre[type]) : null}
            </div>
            <div className="col-md-6">
              <h4>Nearside Rear Tyre</h4>
              {(appraisal?.near_side_rear_tyre[type]) ? this.renderNewKeysAboveMileage(appraisal?.near_side_rear_tyre[type]) : null}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <h4>Offside Front Tyre</h4>
              {(appraisal?.off_side_front_tyre[type]) ? this.renderNewKeysAboveMileage(appraisal?.off_side_front_tyre[type]) : null}
            </div>
            <div className="col-md-6">
              <h4>Nearside Front Tyre</h4>
              {(appraisal?.near_side_front_tyre[type]) ? this.renderNewKeysAboveMileage(appraisal?.near_side_front_tyre[type]) : null}
            </div>
          </div>
          <hr />
          {shouldShow && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <h4>Spare Wheel</h4>
                  {(appraisal?.spare_wheel) ? this.renderSpareWheel(appraisal?.spare_wheel, 'uploadcare_image_urls', type) : null}
                </div>
                <div className="col-md-6">
                  <h4>Inflation Kit</h4>
                  {(appraisal?.inflation_kit) ? this.renderInflationKit(appraisal?.inflation_kit, type) : null}
                </div>
              </div>
              <hr />
            </>
          )}
          <div className="row">
            <div className="col-md-6">
              <h4>Parcel Shelf</h4>
              {(appraisal?.parcel_shelf) ? this.renderNewKeysAboveMileage(appraisal?.parcel_shelf[type]) : null}
            </div>
            <div className="col-md-6">
              <h4>Front Interior</h4>
              {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'uploadcare_image_urls', type) : null}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-6">
              <h4>Front Interior Headrest</h4>
              {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'headrest_uploadcare_image_urls', type) : null}
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Number Of Keys</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.number_of_keys &&
                    appraisal.number_of_keys[type] &&
                    appraisal.number_of_keys[type].entry) ? (
                    <h5>
                      <strong>
                        {parseInt(appraisal?.number_of_keys?.[type]?.entry || 0, 10)}
                      </strong>
                    </h5>
                  ) : (
                    <h5>No entry.</h5>
                  )}
                </div>
              </div>
              {(appraisal?.number_of_keys) ? this.renderNewKeysAboveMileage(appraisal?.number_of_keys[type]) : null}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <h4>Reading Lights</h4>
              {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'reading_lights_uploadcare_image_urls', type) : null}
            </div>
            <div className="col-md-6">
              <h4>Steering Wheel</h4>
              {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'steering_wheel_uploadcare_image_urls', type) : null}
            </div>
          </div>
          <hr />
          {shouldShow && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <h4>Rear View Mirror</h4>
                  {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'rear_view_mirror_uploadcare_image_urls', type) : null}
                  <br />
                </div>
                <div className="col-md-6">
                  <h4>Sat Nav Disc/SD Card</h4>
                  {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'set_nav_disk_or_sbcard_uploadcare_image_urls', type) : null}
                </div>
              </div>
              <hr />
            </>
          )}
          <div className="row">
            <div className="col-md-6">
              <h4>Rear Interior</h4>
              {(appraisal?.rear_interior) ? this.renderRearInterior(appraisal?.rear_interior, 'uploadcare_image_urls', type) : null}
            </div>
            <div className="col-md-6">
              <h4>Rear Interior headrest</h4>
              {(appraisal?.rear_interior) ? this.renderRearInterior(appraisal?.rear_interior, 'headrest_uploadcare_image_urls', type) : null}
            </div>
          </div>
          <hr />

          {/* Show Front & Rear ONLY when locking_wheel_nut is NOT present */}
          {!appraisal?.locking_wheel_nut && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <h4>Front Locking Wheel Nut</h4>
                  {appraisal?.front_locking_wheel_nut
                    ? this.renderNewKeysAboveMileage(appraisal.front_locking_wheel_nut[type])
                    : null}
                </div>
                <div className="col-md-6">
                  <h4>Rear Locking Wheel Nut</h4>
                  {appraisal?.rear_locking_wheel_nut
                    ? this.renderNewKeysAboveMileage(appraisal.rear_locking_wheel_nut[type])
                    : null}
                </div>
              </div>
              <hr />
            </>
          )}

          {/* Always prioritize this */}
          {/* {appraisal?.locking_wheel_nut && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <h4>Locking Wheel Nuts: {lockingWheelNutValue === true || lockingWheelNutValue === "true" ? "Yes" : "No"}</h4>
                  {this.renderNewKeysAboveMileage(appraisal.locking_wheel_nut[type])}
                </div>
              </div>
              <hr />
            </>
          )} */}
          <div className="row">
            <div className="col-md-6">
              <h4>Service Book</h4>
              {(appraisal?.service_book) ? this.renderNewKeysAboveMileage(appraisal?.service_book[type]) : null}
            </div>
            <div className="col-md-6">
              <h4>Handbook</h4>
              {(appraisal?.rear_locking_wheel_nut) ? this.renderNewKeysAboveMileage(appraisal?.handbook[type]) : null}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <h4>V5 Document</h4>
              {(appraisal?.v5_registration_document) ? this.renderNewKeysAboveMileage(appraisal?.v5_registration_document[type]) : null}
            </div>
            {/* {type === 'pickup' && */}
            <div className="col-md-6">
              <h4>Dashcam</h4>
              {appraisal?.dashcam?.[type] &&
                this.renderNewKeysAboveMileage(appraisal?.dashcam[type])
              }
            </div>
            {/* } */}
            <br />
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <h4>Charging Cable</h4>
              {(appraisal?.front_interior) ? this.renderFrontInterior(appraisal?.front_interior, 'charging_cable_uploadcare_image_urls', type) : null}
            </div>
            <div className="col-md-6">

            </div>
          </div>
          <hr />
          <h4 className="text-center">Other Images</h4>
          <div className="row align-items-start">
            <div className="col-12">
              {appraisal?.other_images?.[type]?.images?.length > 0
                ? this.renderNewKeysAboveMileage(appraisal.other_images[type])
                : null}
            </div>
          </div>
          <hr />
          <div className="appraisal-vehicle-info-line-container row">
            <div className="appraisal-vehicle-info-line col-md-6 col-sm-12">
              <div className="appraisal-vehicle-info-line-label" style={{ width: '100%' }} >Front Notes:
                {appraisal?.front?.[type]?.note ? (
                  <h5>
                    <strong>{appraisal.front[type].note}</strong>
                  </h5>
                ) : (
                  <h5></h5>
                )}
              </div>
            </div>

            <div className="appraisal-vehicle-info-line col-md-6 col-sm-12">
              <div className="appraisal-vehicle-info-line-label" style={{ width: '100%' }}>Rear Notes:
                {appraisal?.rear?.[type]?.note ? (
                  <h5>
                    <strong>{appraisal.rear[type].note}</strong>
                  </h5>
                ) : (
                  <h5></h5>
                )}
              </div>
            </div>

            <div className="appraisal-vehicle-info-line col-md-6 col-sm-12">
              <div className="appraisal-vehicle-info-line-label" style={{ width: '100%' }}>
                Passenger Side Notes: {appraisal?.near_side?.[type]?.note ? (
                  <h5>
                    <strong>{appraisal.near_side[type].note}</strong>
                  </h5>
                ) : (
                  <h5></h5>
                )}
              </div>
            </div>

            <div className="appraisal-vehicle-info-line col-md-6 col-sm-12">
              <div className="appraisal-vehicle-info-line-label" style={{ width: '100%' }}>
                Driver Side Notes:  {appraisal?.off_side?.[type]?.note ? (
                  <h5>
                    &nbsp;<strong>{appraisal.off_side[type].note}</strong>
                  </h5>
                ) : (
                  <h5></h5>
                )}
              </div>
            </div>

            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Horn</div>
              <div class="appraisal-vehicle-info-line-value">
                {hornValue === true || hornValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Radio</div>
              <div class="appraisal-vehicle-info-line-value">
                {radioValue === true || radioValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Wiper</div>
              <div class="appraisal-vehicle-info-line-value">
                {wiperValue === true || wiperValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Windows (Faults)</div>
              <div class="appraisal-vehicle-info-line-value">
                {windowsValue === true || windowsValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Aircon</div>
              <div class="appraisal-vehicle-info-line-value">
                {airconValue === true || airconValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Sat Nav Disc/SD Card</div>
              <div class="appraisal-vehicle-info-line-value">
                {satNavValue === true || satNavValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Rear View Mirror</div>
              <div class="appraisal-vehicle-info-line-value">
                {rearViewMirrorValue === true || rearViewMirrorValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Charging Cable</div>
              <div class="appraisal-vehicle-info-line-value">
                {chargingCableValue === true || chargingCableValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Inflation Kit</div>
              <div class="appraisal-vehicle-info-line-value">
                {inflationKitValue === true || inflationKitValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Front Windscreen</div>
              <div class="appraisal-vehicle-info-line-value">
                {frontWindscreenKitValue === true || frontWindscreenKitValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Rear Windscreen</div>
              <div class="appraisal-vehicle-info-line-value">
                {rearWindscreenKitValue === true || rearWindscreenKitValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Spare Wheel</div>
              <div class="appraisal-vehicle-info-line-value">
                {spareWheelValue === true || spareWheelValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Jack</div>
              <div class="appraisal-vehicle-info-line-value">
                {jackValue === true || jackValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Wrench</div>
              <div class="appraisal-vehicle-info-line-value">
                {wrenchValue === true || wrenchValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div class=" appraisal-vehicle-info-line col-md-4 col-sm-12">
              <div class="appraisal-vehicle-info-line-label">Extension Bar</div>
              <div class="appraisal-vehicle-info-line-value">
                {extensionBarValue === true || extensionBarValue === "true" ? "Yes" : "No"}
              </div>
            </div>
            <div className={`appraisal-vehicle-info-line ${lockingWheelNutValue === true || lockingWheelNutValue === "true" ? "col-md-8" : "col-md-4"} col-sm-12`}>
              <div className="appraisal-vehicle-info-line-label">Locking Wheel Nuts</div>
              <div className="appraisal-vehicle-info-line-value">
                {lockingWheelNutValue === true || lockingWheelNutValue === "true" ? "Yes" : "No"}
              </div>
              {(lockingWheelNutValue === true || lockingWheelNutValue === "true") &&
                this.renderNewKeysAboveMileage(appraisal.locking_wheel_nut[type])
              }
            </div>
          </div>
          <h4 className="text-center">Manual Appraisal</h4>
          {/* <h5>Vehicle Info</h5>
          <p> there is no Vehicle Info section in V2 mobile app.</p> */}
          <div>&nbsp;</div>
          <h5>Vehicle Parts</h5>
          {this.renderManualAppraisalVehiclePartsV2(appraisal, type)}
          <hr />
          {/* <h4 className="text-center">Appraisal Feedback</h4> */}
          {/* {this.renderAppraisalFeedbackQuestions(appraisal, type)} */}
          <hr />
          <h4 className="text-center">Video Appraisal</h4>
          <div className="row">
            {this.renderVideoAppraisalBlock(appraisal, type)}
          </div>
          <div className="row">
            <div className="col-md-6">
              {signatureBlock}
            </div>
          </div>
        </div>
      );
    }
    else {
      appraisalInfoBlock = (
        <div className="row" key={'appraisal-info-block-for' + appraisal.id}>
          <div className="col-md-12">
            <p>
              <strong>
                No Appraisal Yet.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    return appraisalInfoBlock;
  }

  renderSpareWheel(spare_wheel, item, type) {
    const spare_wheel_type =
      type === 'pickup' ? 'spare_wheel_pickup' : 'spare_wheel_dropoff';

    const spare_wheel_images =
      spare_wheel?.[spare_wheel_type]?.[item] || [];

    // show placeholder when no images
    if (spare_wheel_images.length === 0) {
      return (
        <div className="appraisal-mileage-images-container">

        </div>
      );
    }

    const VehiclePartImages = spare_wheel_images.map((spare_wheel_image, i) =>
      window.zoomImageForSpecificUser ? (
        <ZoomebleImage
          key={`job-${this.state.data.id}-${item}-${i}`}
          zoom={2}
          zoomWidth={900}
          zoomHeight={900}
          src={spare_wheel_image}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
        />
      ) : (
        <img style={{ width: "100%" }}
          key={`job-${this.state.data.id}-${item}-${i}`}
          src={spare_wheel_image}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
          }}
        />
      )
    );

    return (
      <div className="appraisal-mileage-images-container">
        {VehiclePartImages}
      </div>
    );
  }

  renderInflationKit(part, type) {
    let inflation_kit_type =
      type === 'pickup' ? 'inflation_kit_pickup' : 'inflation_kit_dropoff';

    const inflationKitImages =
      part?.[inflation_kit_type]?.uploadcare_image_urls || [];

    //  show placeholder when no images
    if (inflationKitImages.length === 0) {
      return (
        <div className="appraisal-mileage-images-container">

        </div>
      );
    }

    let VehiclePartImages = [];

    inflationKitImages.forEach((inflationKitImage, i) => {
      VehiclePartImages.push(
        window.zoomImageForSpecificUser ? (
          <ZoomebleImage
            zoom={2}
            zoomWidth={900}
            zoomHeight={900}
            src={inflationKitImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={`job-${this.state.data.id}-inflation_kit-${i}`}
          />
        ) : (
          <img style={{ width: "100%" }}
            src={inflationKitImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={`job-${this.state.data.id}-inflation_kit-${i}`}
          />
        )
      );
    });

    return (
      <div className="appraisal-mileage-images-container">
        {VehiclePartImages}
      </div>
    );
  }

  renderFrontInterior(front_interior, item, type) {
    let front_interior_type = type === 'pickup' ? 'front_interior_pickup' : 'front_interior_dropoff';
    let front_interior_images = [];
    let VehiclePartImages = [];

    if (
      front_interior &&
      front_interior[front_interior_type] &&
      front_interior[front_interior_type][item]
    ) {
      front_interior_images = front_interior[front_interior_type][item];
    }

    //  If no images, show placeholder
    if (!front_interior_images || front_interior_images.length === 0) {
      return (
        <div className="appraisal-mileage-images-container">

        </div>
      );
    }

    //  Otherwise render images
    front_interior_images.forEach((front_interior_image, i) => {
      VehiclePartImages.push(
        window.zoomImageForSpecificUser ? (
          <ZoomebleImage
            zoom={2}
            zoomWidth={900}
            zoomHeight={900}
            src={front_interior_image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={'job-' + this.state.data.id + '-' + item + '-' + i}
          />
        ) : (
          <img style={{ margin: "5px", width: "650px" }}
            src={front_interior_image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={'job-' + this.state.data.id + '-' + item + '-' + i}
          />
        )
      );
    });

    return (
      <div className="appraisal-mileage-images-container">
        {VehiclePartImages}
      </div>
    );
  }

  renderRearInterior(rear_interior, item, type) {
    let rear_interior_type =
      type === 'pickup' ? 'rear_interior_pickup' : 'rear_interior_dropoff';
    let rear_interior_images = [];
    if (
      rear_interior &&
      rear_interior[rear_interior_type] &&
      rear_interior[rear_interior_type][item]
    ) {
      rear_interior_images = rear_interior[rear_interior_type][item];
    }
    //  Show placeholder if no images
    if (!rear_interior_images || rear_interior_images.length === 0) {
      return (
        <div className="appraisal-mileage-images-container">
          <img
            style={{ width: "100%" }}
            src="/images/placeholders/appraisal-placeholder-305_228.png"
            alt="placeholder"
          />
        </div>
      );
    }

    //  Render images
    const VehiclePartImages = rear_interior_images.map(
      (rear_interior_image, i) =>
        window.zoomImageForSpecificUser ? (
          <ZoomebleImage
            zoom={2}
            zoomWidth={900}
            zoomHeight={900}
            src={rear_interior_image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={`job-${this.state.data.id}-${item}-${i}`}
          />
        ) : (
          <img
            style={{ width: "100%" }}
            src={rear_interior_image}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/appraisal-placeholder-305_228.png";
            }}
            key={`job-${this.state.data.id}-${item}-${i}`}
          />
        )
    );

    return (
      <div className="appraisal-mileage-images-container">
        {VehiclePartImages}
      </div>
    );
  }

  render() {
    var downloadButtonText = '';
    if (this.state.isDownloadClick) {
      downloadButtonText = 'Downloading ... ';
    }
    else {
      downloadButtonText = '<i className="fa fa-download"></i> Download <span className="uc-first">' + this.state.type + '</span> Appraisal as PDF';
    }
    if (this.appraisalIsNotDoneFromDriverApp()) {
      return (<div className="class alert alert-info">
        <i className='fa fa-info-circle'></i>
        &nbsp; Appraisal is not stored due to customer request. Please check <strong>Manual Appraisal Required From Driver App?</strong> under this job settings tab.
      </div>)
    }
    return (
      <div>
        &nbsp;
        <small>
          <em>- generated {
            moment().format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }</em>
        </small>
        {this.state.isLoadingAppraisalInfo ?
          <div className="loading-box">
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div> :
          this.state.data && this.state.data.id ?
            <div>
              <a href="#"
                onClick={(e) => {
                  this.downloadAppraisalForJob(e,
                    "job-" + this.state.data.id + "-" + this.state.type + "-appraisal",
                    moment().format('ddd Do MMM YYYY - HH:mm:ss')
                  )
                }}
                className="btn btn-lg btn-success appraisal-download-button pickDropAppraisal">
                <div dangerouslySetInnerHTML={{ __html: downloadButtonText }} />
              </a>
              <br />
              <div className="row">
                <div className="col-md-4">
                  {(this.state.data && this.state.data.id && !this.state.customerAllJobsPage && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ?
                    (this.state.type == "pickup") ?
                      (this.state.data.approve_pickup_appraisal) ?
                        <button className="btn btn-dark pickup font-16"
                          onClick={(e) => { this.unapproveAppraisal(e, this.state.type) }}>
                          UnApprove {this.state.type} Appraisal to be shown on customer login
                        </button>
                        :
                        <button className="btn btn-primary pickup font-16"
                          onClick={(e) => { this.approveAppraisal(e, this.state.type) }}>
                          Approve {this.state.type} Appraisal to be shown on customer login
                        </button>
                      : ""
                    : ""}
                  {(this.state.data && this.state.data.id && !this.state.customerAllJobsPage && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ?
                    (this.state.type == "dropoff") ?
                      (this.state.data.approve_dropoff_appraisal) ?
                        <button className="btn btn-dark dropoff font-16"
                          onClick={(e) => { this.unapproveAppraisal(e, this.state.type) }}>
                          UnApprove {this.state.type} Appraisal to be shown on customer login
                        </button>
                        :
                        <button className="btn btn-primary dropoff font-16"
                          onClick={(e) => { this.approveAppraisal(e, this.state.type) }}>
                          Approve {this.state.type} Appraisal to be shown on customer login
                        </button>
                      : ""
                    : ""}
                </div>
                {(this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ?
                  <div className="col-md-4">
                    <button className="btn btn-dark dropoff font-16 text-uppercase"
                      onClick={(e) => { this.sendAppraisalPdfMailToCustomer(e, this.state.type) }}>
                      SEND {this.state.type} APPRAISAL PDF {(this.state.customerAllJobsPage) ? 'BY EMAIL' : 'MAIL TO CUSTOMER'}
                    </button>
                  </div>
                  : ""}

                {(this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && this.state.data.customer && this.state.data.customer.disclaimer && "number_plate" in this.state.appraisal_data) ?
                  <div className="col-md-2">
                    <textarea className="form-control form-control-lg"
                      id="customer_disclaimer"
                      readOnly={true}
                      defaultValue={this.state.data.customer.disclaimer ?? ''}>
                    </textarea>
                  </div>
                  : ""}


                {((this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "expenses" in this.state.appraisal_data) && (this.state.type == "dropoff")) ?
                  <div className="col-md-2">
                    <button className="btn btn-dark dropoff font-16 text-uppercase d-none"
                      onClick={(e) => { this.sendMultipleExpenseMailToPeople(this.state.data.id) }}
                    > {(this.state.sending_expenses) ? <span><i className='fas fa-circle-notch fa-spin'></i> sending...</span> : "send expenses"}
                    </button>
                  </div>
                  : ""}
              </div>


              <br /><br />
              {this.state.type == "dropoff" && this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data ?
                <button className="btn btn-primary pull-right" onClick={(e) => { this.handleCheckDiffAppraisals(e) }}>Check Appraisal</button> :
                ''
              }
              {(this.state.appraisal_data?.schemaVersion == 'V2') ?
                this.renderAppraisalInfoBlockV2(this.state.type) :
                this.renderAppraisalInfoBlock(this.state.type)
              }
              <small> App Version : {this.state.appraisal_data.appVersion} | Schema Version : {this.state.appraisal_data.schemaVersion} </small>
            </div>
            : alert('no id')
        }
      </div>
    );
  }
}